module.exports = __webpack_public_path__ + "static/media/detail-email.ea02a2ce.jpg";